
import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AssistantPage from "./pages/AssistantPage";

const queryClient = new QueryClient();

// Route logger component to debug navigation
const RouteLogger = () => {
  const location = useLocation();
  
  React.useEffect(() => {
    console.log("Current route:", location.pathname);
  }, [location]);
  
  return null;
};

const App = () => (
  <ThemeProvider defaultTheme="light">
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <RouteLogger />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/assistant/:key_id" element={<AssistantPage />} />
            {/* Default route - redirect to the default assistant */}
            <Route path="/assistant" element={<Navigate to="/assistant/midnight-hotel" replace />} />
            {/* Legacy route format support */}
            <Route path="/:key_id" element={<AssistantPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
